module.exports = __webpack_public_path__ + "static/media/annotation-layers.cc6d0e6b.svg";